import { useAuth } from '@/core/auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useEstimates } from '../shared/hooks/useEstimates';
import { EstimatesKpi } from './components/EstimatesKpi';
import { EstimatesGrid } from './components/EstimatesGrid';
import { StandardListLayout } from '@/shared/layout/StandardListLayout';
import { DataFilterToolbar, type FilterDefinition } from '@/components/ui/DataFilterToolbar';
import { Plus, Download } from 'lucide-react';
import type { EstimateStatus } from '../shared/types/estimate.types';

const statusTabs: Array<{ value: EstimateStatus | 'all'; label: string }> = [
  { value: 'all', label: 'Tất cả' },
  { value: 'draft', label: 'Nháp' },
  { value: 'reviewing', label: 'Đang duyệt' },
  { value: 'approved', label: 'Đã duyệt' },
  { value: 'converted_to_boq', label: 'Đã chuyển BOQ' },
];

export function EstimateListPage() {
  const navigate = useNavigate();
  const { profile } = useAuth();
  const companyId = profile?.company_id || '';
  const { items, stats, filters, setFilters, isLoading, error } = useEstimates(companyId);

  const filterDefs: FilterDefinition[] = [
    {
      id: 'status',
      label: 'Danh mục',
      options: statusTabs
    },
    {
      id: 'project_id',
      label: 'Dự án',
      options: [{ value: 'all', label: 'Tất cả dự án' }] // Mock cho demo
    },
    {
      id: 'created_by',
      label: 'Người lập',
      options: [{ value: 'all', label: 'Tất cả người lập' }] // Mock cho demo
    }
  ];

  return (
    <StandardListLayout
      title="Dự toán & Báo giá"
      description="Quản lý dự toán cảnh quan cây xanh theo dự án, báo giá lẻ và luồng chuyển BOQ"
      isLoading={isLoading}
      viewMode="grid"
      kpiSection={<EstimatesKpi stats={stats} isLoading={isLoading} />}
      toolbarSection={
        <DataFilterToolbar
          search={filters.search || ''}
          onSearchChange={(v) => setFilters(curr => ({ ...curr, search: v }))}
          searchPlaceholder="Tìm mã, tên dự toán..."
          filterDefs={filterDefs}
          filterValues={{
            status: filters.status || 'all',
            project_id: filters.project_id || 'all',
            created_by: filters.created_by || 'all'
          }}
          onFilterChange={(k, v) => setFilters(curr => ({ ...curr, [k]: v === 'all' ? undefined : v }))}
          primaryAction={{
            label: "Tạo mới",
            icon: Plus,
            onClick: () => navigate('/estimates/new')
          }}
          secondaryActions={[
            {
              label: "Xuất báo cáo",
              icon: Download,
              onClick: () => {}
            }
          ]}
        />
      }
      cardSection={
        <EstimatesGrid
          items={items}
          isLoading={isLoading}
          error={error}
          onItemClick={(id) => navigate(`/estimates/${id}`)}
        />
      }
    />
  );
}
